import axios from "axios";
import { apiVariable } from "./apiVariable";
import {
  EmployeeDto,
  EmployeePositionHistoryDto,
} from "../interfaces/HR/employee";

export const getNewHiredEmployees = async (token: string) => {
  const { data } = await axios.get<EmployeeDto[]>(
    `${apiVariable}/getNewHiredEmployees`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return data;
};

export const getUpcomingBirthdays = async (token: string, daysAhead = 30) => {
  const { data } = await axios.get<EmployeeDto[]>(
    `${apiVariable}/getUpcomingBirthdays?daysAhead=${daysAhead}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const getUpcomingWorkAnniversaries = async (
  token: string,
  daysAhead = 30
) => {
  const { data } = await axios.get<EmployeeDto[]>(
    `${apiVariable}/getUpcomingWorkAnniversaries?daysAhead=${daysAhead}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const getTotalEmployees = (token: string) =>
  axios.get<number>(`${apiVariable}/totalEmployees`, { headers: { Authorization: `Bearer ${token}` } })
    .then(r => r.data);

export const getEmployeeCountByDepartment = (token: string) =>
  axios.get<Record<string, number>>(`${apiVariable}/employeeCountByDepartment`, { headers: { Authorization: `Bearer ${token}` } })
    .then(r => r.data);

export const getEmployeeCountByDeliveryUnit = (token: string) =>
  axios.get<Record<string, number>>(`${apiVariable}/employeeCountByDeliveryUnit`, { headers: { Authorization: `Bearer ${token}` } })
    .then(r => r.data);

export const getTruckCountByMakeModel = (token: string) =>
  axios.get<Record<string, number>>(`${apiVariable}/truckCountByMakeAndModel`, { headers: { Authorization: `Bearer ${token}` } })
    .then(r => r.data);

export const getTrailerCountByMakeModel = (token: string) =>
  axios.get<Record<string, number>>(`${apiVariable}/trailerCountByMakeAndModel`, { headers: { Authorization: `Bearer ${token}` } })
    .then(r => r.data);

export const getEmployeePositionHistory = async (
  token: string,
  employeeId: string
) => {
  const { data } = await axios.get<EmployeePositionHistoryDto[]>(
    `${apiVariable}/hr/employees/${employeeId}/position-history`,
    {
      headers: { Authorization: `Bearer ${token}` }
    });
  return data;
};
